<hw-page-header header="mdm.measurement-unit-01.header" class="page-header"></hw-page-header>
<nz-content class="main" *hwPrivileged="viewPrivileges">
  <hw-table>
    <div headerContent>
      <input
        nz-input
        name="filter"
        [(ngModel)]="search"
        [placeholder]="'mdm.measurement-unit-01.quick-search' | translate"
        style="width: 300px" />
      <button class="button" [routerLink]="['add']" nz-button nzType="secondary" *hwPrivileged="editPrivileges">
        {{ 'core.btn.add-new' | translate }}
      </button>
    </div>

    <nz-table
      #table
      [nzData]="measurementUnits | textSearch : { '*': search }"
      [nzSize]="'small'"
      [nzPageSize]="100"
      [nzHideOnSinglePage]="true">
      <thead>
        <tr>
          <th>{{ 'mdm.measurement-unit-01.code' | translate }}</th>
          <th>{{ 'mdm.measurement-unit-01.name' | translate }}</th>
          <th>{{ 'mdm.measurement-unit-01.alias' | translate }}</th>
          <th>{{ 'mdm.measurement-unit-01.rounding' | translate }}</th>
          <th>{{ 'mdm.measurement-unit-01.kind' | translate }}</th>
          <th>{{ 'mdm.measurement-unit-01.definition-unit' | translate }}</th>
          <th>{{ 'mdm.measurement-unit-01.definition-value' | translate }}</th>
          <th>{{ 'mdm.measurement-unit-01.period' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of table.data">
          <td>
            <a [routerLink]="['edit/', item.id]">{{ item.code }}</a>
          </td>
          <td>{{ item.names | localName }}</td>
          <td>{{ item.alias | localName }}</td>
          <td>{{ item.rounding }}</td>
          <td>{{ item.kind?.code | localizedConceptName : 'measurement-unit-kind' | async }}</td>
          <td>{{ item.definitionUnit }}</td>
          <td>{{ item.definitionValue }}</td>
          <td>{{ item.period?.lower | localDate }} - {{ item.period?.upper | localDate }}</td>
        </tr>
      </tbody>
    </nz-table>
  </hw-table>
</nz-content>
